import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../configure_store'

const _getState = (state: RootState) => state.memberBenefits

export const getMemberBenefits = createSelector(
  _getState,
  (state) => (
    state.memberBenefits
  )
)

export const getMemberBenefit = (id: string) => createSelector(
  _getState,
  (state) => (
    state.memberBenefits.find(memberBenefit => `${memberBenefit.id}` === id)
  )
)

export const getIsMemberBenefitLoading = createSelector(
  _getState,
  (state) => (
    state.isLoading
  )
)
